import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Menu from "./components/Menu";
import Gallery from "./components/Gallery";
import ScrollToTop from "./components/ScrollToTop";
import Reservation from "./components/Reservation";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50">
        <ScrollToTop /> {/* Scroll to top on route change */}

        {/* Header stays on every page */}
        <Header />

        <main>
          <Routes>
            {/* Home Page */}
            <Route path="/" element={<Hero />} />

            {/* Other Pages */}
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="reservation" element={<Reservation />} />
          </Routes>
        </main>

        {/* Footer stays on every page */}
        <Footer />

      </div>
    </BrowserRouter>
  );
}

export default App;